import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import $ from "jquery";
import { Provider } from "react-redux";
import store from "./data/store/store";
import { useEffect } from "react";
import { loadUser } from "./data/store/reducers/userSlice";
import DashboardLayout from "./layout/layout";
import Overview from "./pages";
import AllUsers from "./pages/users/all";
import Professionals from "./pages/users/professionals";
import Employers from "./pages/users/employers";
import SignIn from "./screens/sign-in";
import Jobs from "./pages/posts/jobs";
import Projects from "./pages/posts/projects";
import Applications from "./pages/applications";
import Interviews from "./pages/interviews";
import Transactions from "./pages/transactions";
import Categories from "./pages/categories";
import Industries from "./pages/industries";
import Settings from "./pages/settings";
import { useAppSelector } from "./data/store/hooks";
import UserDetails from "./pages/users/user-details";
import { BeatLoader } from "react-spinners";

$(window).on("load", function () {
  $(".lds-ellipsis").fadeOut();
  $(".preloader").delay(333).fadeOut("slow");
  $("body").delay(333);
});

const queryClient = new QueryClient();

const InnerApp = () => {
  const isAuth = useAppSelector((state) => state.user.isAuth);
 const loading = useAppSelector((state) => state.user.loading);

  const router = createBrowserRouter([
    {
      path: "/",
      element: isAuth ? <DashboardLayout /> : <SignIn />,
      children: [
        {
          path: "/",
          element: <Overview />,
        },
        {
          path: "/users/all",
          element: <AllUsers />,
        },
        {
          path: "/users/professionals",
          element: <Professionals />,
        },
        {
          path: "/users/employers",
          element: <Employers />,
        },
        {
          path: "/users/:id",
          element: <UserDetails />,
        },
        {
          path: "/posts/jobs",
          element: <Jobs />,
        },
        {
          path: "/posts/projects",
          element: <Projects />,
        },
        {
          path: "/applications",
          element: <Applications />,
        },
        {
          path: "/interviews",
          element: <Interviews />,
        },
        {
          path: "/transactions",
          element: <Transactions />,
        },
        {
          path: "/categories",
          element: <Categories />,
        },
        {
          path: "/industries",
          element: <Industries />,
        },
        {
          path: "/settings",
          element: <Settings />,
        },
      ],
    },
    {
      path: "/auth/sign-in",
      element: <SignIn />,
    },
  ]);

  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <BeatLoader size={50} color="#3B82F6" />
      </div>
    );
  }

  
  return <RouterProvider router={router} />;
};

function App() {
  return (
    <>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <InnerApp />
        </QueryClientProvider>
      </Provider>
    </>
  );
}

export default App;
